export default "__VITE_ASSET__DUbtbmS5__"